import { Auth, API } from 'aws-amplify';
import { COGNITO_SERVICE } from 'utils/const';

const getHeaders = async () => {
  const authorisation = `${(await Auth.currentSession())
    .getAccessToken()
    .getJwtToken()}`;

  return {
    'Content-Type': 'application/json',
    Authorization: authorisation,
  };
};

export const getUnassignedMembers = async ({ limit }) => {
  const myInit = {
    queryStringParameters: {
      limit,
    },
    headers: await getHeaders(),
  };
  try {
    const response = await API.get(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.GET_UNASSIGNED_MEMBERS,
      myInit,
    );
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

export const getAssignedMembers = async ({ limit }) => {
  const myInit = {
    queryStringParameters: {
      limit,
    },
    headers: await getHeaders(),
  };
  try {
    const response = await API.get(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.GET_ASSIGNED_MEMBERS,
      myInit,
    );
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};

export const listUsers = async ({ limit }) => {
  const myInit = {
    queryStringParameters: {
      limit,
    },
    headers: await getHeaders(),
  };
  try {
    const { Users } = await API.get(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.LIST_USERS,
      myInit,
    );
    return { data: Users };
  } catch (err) {
    return { error: err.message };
  }
};

export const listUsersInGroup = async ({ groupName, limit }) => {
  const myInit = {
    queryStringParameters: {
      groupname: groupName,
      limit,
    },
    headers: await getHeaders(),
  };
  try {
    const { Users } = await API.get(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.LIST_USERS_IN_GROUP,
      myInit,
    );
    return { data: Users };
  } catch (err) {
    return { error: err.message };
  }
};

export const deleteUser = async ({ email }) => {
  const myInit = {
    body: {
      username: email,
    },
    headers: await getHeaders(),
  };
  try {
    const res = await API.post(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.DELETE_USER,
      myInit,
    );
    return { data: res };
  } catch (err) {
    return { error: err.message };
  }
};

export const removeUserFromGroup = async ({ email, groupName }) => {
  const myInit = {
    body: {
      username: email,
      groupname: groupName,
    },
    headers: await getHeaders(),
  };
  try {
    const res = await API.post(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.REMOVE_USER_FROM_GROUP,
      myInit,
    );
    return { data: res };
  } catch (err) {
    return { error: err.message };
  }
};

export const addUserToGroup = async ({ email, groupName }) => {
  const myInit = {
    body: {
      username: email,
      groupname: groupName,
    },
    headers: await getHeaders(),
  };
  try {
    const res = await API.post(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.ADD_USER_TO_GROUP,
      myInit,
    );
    return { data: res };
  } catch (err) {
    return { error: err.message };
  }
};

export const updateUserAttributes = async ({ email, userAttributes }) => {
  const myInit = {
    body: {
      username: email,
      userAttributes, // [{ Name: 'custom:team', Value: 'admin' }]
    },
    headers: await getHeaders(),
  };
  try {
    const res = await API.post(
      COGNITO_SERVICE.API,
      COGNITO_SERVICE.PATHS.UPDATE_USER_ATTRIBUTES,
      myInit,
    );
    return { data: res };
  } catch (err) {
    return { error: err.message };
  }
};
